import { PropsWithChildren } from 'react';
import { makeStyles } from '@material-ui/core';

// Backstage's Table has no option to put its filters on the right, so this
// reverses its two flex rows: the toolbar (filter toggle, then title and
// search) and the body (filter panel, then table). The filter panel only
// renders while open, so its spacing is moved only when it has a sibling.
const TOOLBAR = 'div:has(> div > button[aria-label="filter list"])';
const useStyles = makeStyles(theme => ({
  root: {
    [`& ${TOOLBAR}`]: {
      flexDirection: 'row-reverse',
      paddingRight: theme.spacing(2),
    },
    [`& ${TOOLBAR} > :last-child`]: { flex: 1 },
    '& > div': { flexDirection: 'row-reverse' },
    // The table sets an inline width of 100%, which overflows once the filter
    // panel sits beside it; let it shrink into the remaining space instead.
    // Clipping lets the table's own horizontal scroll take over rather than
    // the table pushing out of the page.
    // Class names carry generated suffixes here (MuiPaper-root-123), so match
    // on the prefix.
    '& > div > [class*="MuiPaper-root"]': {
      flex: 1,
      minWidth: 0,
      width: 'auto !important',
      overflow: 'hidden',
    },
    '& > div > div:first-child:not(:only-child)': {
      marginRight: 0,
      marginLeft: theme.spacing(3),
      paddingRight: theme.spacing(2),
      flexShrink: 0,
    },
  },
}));

/** Show a Backstage Table's title on the left and its filters on the right. */
export const FiltersOnRight = ({ children }: PropsWithChildren<{}>) => (
  <div className={useStyles().root}>{children}</div>
);
